import React from "react";

/**
 * Нейтральная полоса над дорожками: что редактор сделал сам — без вопроса, но не по ошибке.
 * Сейчас это «Наложение снято…»: в режиме «Без автоправок» наехавшая озвучка отодвигается позже
 * (правило владельца 01.10.2026), и переводчик должен видеть, что её передвинул не он.
 *
 * Не красная и не в канале отказов (EditorErrorBanner / translatedOpError): там она выглядела
 * отказом сервера, а окно разбиения показывало старое сообщение как ошибку своей операции.
 * Висит, пока её не закроют или не сменит следующий сдвиг.
 */
export const EditorNoticeBanner = ({
    message,
    onClose,
}: {
    message: string | null;
    onClose: () => void;
}) => {
    if (!message) return null;
    return (
        <div
            data-editor-notice="true"
            role="status"
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 8,
                padding: "6px 12px",
                backgroundColor: "#e6f4ff",
                border: "1px solid #91caff",
                color: "#003eb3",
                fontSize: 13,
            }}
        >
            <span>{message}</span>
            <span
                data-close-notice="true"
                role="button"
                style={{ cursor: "pointer", fontWeight: 600, padding: "0 4px", flexShrink: 0 }}
                onClick={onClose}
            >
                ✕
            </span>
        </div>
    );
};
